<template>
  <div>
    <el-row class="btnrow">
      <el-row class="btn">
        <el-col :span="4" class="al" v-if="type == 3">
          <!-- <div class="leftgroup"></div>
          <div class="rightgroup"></div>-->
          <el-radio-group
            v-model="selectRadioType"
            size="small"
            @change="selectRadioTypeChange"
            v-if="type == 3"
          >
            <el-radio-button label="0">任务</el-radio-button>
            <el-radio-button label="1">工作记录</el-radio-button>
          </el-radio-group>
          <!-- <el-button-group v-else>
            <el-button size="medium" type="primary" class="leftgroup">
              <div class="list"></div>
            </el-button>
            <el-button size="medium" type="primary" class="rightgroup">
              <div class="card"></div>
            </el-button>
          </el-button-group>-->
        </el-col>
        <el-col :span="type == 3 ? 20 : 24" class="but">
          <!-- <el-button-group>
        <el-button
            :type="buttonType"

            :class="isEvaluate?'btn-hidden':btnLeftRight"
            icon="iconfont icon-pingjia"
            @click="evaTask"
            :size="buttonSize"
            :disabled="isEvaluate"
          >评价</el-button>-->
          <el-button
            v-if="resultList.length > 0"
            :type="buttonType"
            :size="buttonSize"
            icon="el-icon-s-operation"
            :class="btnLeftRight"
            @click="setTaskRelation"
          >合并任务</el-button>
          <el-button
            v-if="isEditName"
            :type="buttonType"
            :size="buttonSize"
            icon="iconfont icon-xiugaimima"
            :class="!updateNameShow ? 'btn-hidden' : btnLeftRight"
            @click="updateNewTaskName"
          >修改名称</el-button>
          <!-- <el-button
            :type="buttonType"

            :size="buttonSize"
            icon="iconfont icon-xiugaimima"
            class="btn-normal"
            style="float: left;"
            @click='updateTemplate'
          >自定义评估模板</el-button>-->
          <el-button
            :type="buttonType"
            :size="buttonSize"
            icon="iconfont icon-zhoubaozongjie1"
            :class="!completeShow ? 'btn-hidden' : btnLeftRight"
            v-show="processDelayShow"
            @click="delayTaskProcess"
          >进度延期申请</el-button>
          <el-button
            :type="buttonType"
            :size="buttonSize"
            icon="iconfont icon-zongjie"
            :class="!completeShow ? 'btn-hidden' : btnLeftRight"
            v-show="responseDelayShow"
            @click="delayTaskResponse"
          >操作延期申请</el-button>
          <el-button
            :type="buttonType"
            :class="!acceptShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-jushouxiaoxi"
            @click="unAcceptTaskHandle"
            :size="buttonSize"
            :disabled="!acceptShow"
          >不接收</el-button>
          <el-button
            :type="buttonType"
            :class="!acceptShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-jieshou"
            @click="acceptTaskHandle"
            :size="buttonSize"
            :disabled="!acceptShow"
          >接收</el-button>
          <el-button
            :type="buttonType"
            :class="!convertShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-liuzhuanzhan"
            @click="showConvertTaskDialog"
            :size="buttonSize"
            :disabled="!convertShow"
          >流转</el-button>
          <el-button
            :type="buttonType"
            v-if="!isUrge"
            :class="!urgeShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-cuiban"
            @click="urgeTaskHandle"
            :size="buttonSize"
            :disabled="!urgeShow"
          >催办</el-button>
          <el-button
            :type="buttonType"
            :class="!cancelShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-zuofei"
            @click="cancelTaskHandle"
            :size="buttonSize"
            :disabled="!cancelShow"
          >作废</el-button>
          <el-button
            :type="buttonType"
            :class="!completeShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-querenyuanzhengqueduigoutijiaochenggongwancheng"
            @click="completeTaskHandle"
            :size="buttonSize"
            :disabled="!completeShow"
          >完成</el-button>
          <!-- <el-button
            :type="buttonType"

            :class="!summaryShow?'btn-hidden':btnLeftRight"
            icon="iconfont icon-zongjie"
            @click="summaryTaskHandle"
            :size="buttonSize"
            :disabled="!summaryShow"
          >总结</el-button>-->
          <el-button
            :type="buttonType"
            :class="!rebackShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-dahui"
            @click="rebackTaskHandle"
            :size="buttonSize"
            :disabled="!rebackShow"
          >打回</el-button>
          <el-button
            :type="buttonType"
            :class="!closeShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-pingjia"
            @click="evaluationTaskHandle"
            :size="buttonSize"
            :disabled="!closeShow"
          >关闭</el-button>
          <el-button
            :type="buttonType"
            icon="iconfont icon-querenyuanzhengqueduigoutijiaochenggongwancheng"
            :class="!appraise ? 'btn-hidden' : btnLeftRight"
            @click="appraiseTask"
            :disabled="!appraise"
            :size="buttonSize"
          >评分</el-button>
          <el-button
            :type="buttonType"
            icon="iconfont icon-querenyuanzhengqueduigoutijiaochenggongwancheng"
            :class="!appraise2 ? 'btn-hidden' : btnLeftRight"
            @click="appraiseTaskInfo"
            :disabled="!appraise2"
            :size="buttonSize"
          >已评分</el-button>
          <el-button
            :type="buttonType"
            icon="el-icon-plus"
            :class="!addWorkRecordShow ? 'btn-hidden' : btnLeftRight"
            @click="addWorkRecord"
            v-if="isAddWorkRecord"
            :disabled="!addWorkRecordShow"
            :size="buttonSize"
          >添加工作记录</el-button>
          <el-button
            :type="buttonType"
            icon="el-icon-plus"
            :class="!isCreateTeam ? 'btn-hidden' : btnLeftRight"
            @click="createTeam"
            :disabled="!isCreateTeam"
            :size="buttonSize"
          >创建团队</el-button>
          <el-button
            :type="buttonType"
            icon="iconfont icon-dashujukeshihuaico-"
            :class="!isAddTo ? 'btn-hidden' : btnLeftRight"
            @click="addTo"
            :disabled="!isAddTo"
            :size="buttonSize"
          >添加到</el-button>

          <el-button
            :type="buttonType"
            :class="!deleteShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-dahui"
            @click="deleteTaskHandle"
            :size="buttonSize"
            :disabled="!deleteShow"
          >删除</el-button>
          <el-button
            :type="buttonType"
            :class="!updateShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-dahui"
            @click="updateTaskHandle"
            :size="buttonSize"
            :disabled="!updateShow"
          >编辑</el-button>

          <el-button
            :type="buttonType"
            :class="!copyAddShow ? 'btn-hidden' : btnLeftRight"
            icon="iconfont icon-dahui"
            @click="copyAddTaskHandle"
            :size="buttonSize"
            :disabled="!copyAddShow"
          >复制创建</el-button>
          <!--<el-button
            :type="buttonType"

            :class="!createTaskShow?'btn-hidden':btnLeftRight"
            icon="iconfont icon-dahui"
            @click="rebackTaskHandle"
            :size="buttonSize"
            :disabled="!createTaskShow"
          >生成任务</el-button>
          <el-button
            :type="buttonType"

            icon="iconfont icon-querenyuanzhengqueduigoutijiaochenggongwancheng"
            :class="btnLeftRight"
            @click="recommend"
            :size="buttonSize"
          >推荐</el-button>-->
          <!-- <el-button :type="buttonType"  :class="!subTaskShow?'btn-hidden':btnLeftRight" icon="iconfont icon-task" @click="SubTask" :size="buttonSize"

:disabled="!subTaskShow">子任务</el-button>
          <el-button :type="buttonType" icon="iconfont icon-shenpi" @click="SubFlowTask" :size="buttonSize" :disabled="!subTaskFlowShow">服务申请</el-button>-->
          <!-- <el-button :type="buttonType" icon="iconfont icon-shenpi" :size="buttonSize" :disabled="!auditProcessShow">审核流程</el-button> -->
          <!--<el-dropdown @command="handleCommand">
            <el-button
              :type="buttonType"
              :size="buttonSize"
              :class="!showCreateButton ? 'btn-hidden' : btnLeftRight"
              style="margin-right: 5px;background:rgb(35,185,124);border:1px solid transparent;"
            >
              <i class="el-icon-plus el-icon--right"></i>
              {{ createName }}
            </el-button>
            <el-dropdown-menu slot="dropdown" style="height: 290px;">
              <el-scrollbar style="height: 100%;">
                <el-dropdown-item
                  v-for="(item, index) in taskTypeList"
                  :key="index"
                  :command="item.ID"
                  :icon="'iconfont ' + item.REMARK"
                >{{ item.NAME }}</el-dropdown-item>
              </el-scrollbar>
            </el-dropdown-menu>
          </el-dropdown>-->

          <create-task-dropdown
            ref="CreateTaskDropdown"
            class="btn-normal"
            style="margin-right: 5px;background:rgb(35,185,124);border:1px solid transparent;"
            :type="buttonType"
            :size="buttonSize"
            :showCreateButton="showCreateButton"
            @Success="refreshMode"
          ></create-task-dropdown>
          <!-- </el-button-group> -->
        </el-col>
      </el-row>
      <evaTask ref="evaTask"></evaTask>
      <CreateTaskForm ref="CreateTaskForm" @success="refreshMode"></CreateTaskForm>
      <ConvertTask ref="convertControl" :typeInfo="typeInfo" @convertTaskResult="refreshMode"></ConvertTask>
      <CompleteTask ref="completeControl" @completeTaskResult="refreshMode"></CompleteTask>
      <CreateTask
        ref="CreateTask"
        :parentTask="parentTask"
        :refreshType="refreshType"
        :groupId="groupId"
        :taskGroup="
          isGroup
            ? parentInfo.RELATIONTYPE == 'E9354DE41375' ||
              parentInfo.RELATIONTYPE == 'PUB_GROUP' ||
              parentInfo.NODETYPE == 3
              ? parentInfo.RELATIONID
              : ''
            : ''
        "
        :taskTypeName="taskTypeName"
        @getValue="getValue"
      ></CreateTask>

      <evaluate ref="evaluate" @successed="refreshMode"></evaluate>
      <side-tags-subtask-sub-dialog ref="SideTagsSubtaskSubDialog"></side-tags-subtask-sub-dialog>
      <AuditProcessTaskDialog ref="AuditProcessTaskDialog"></AuditProcessTaskDialog>
      <summaryTaskDialog ref="summaryTaskDialog"></summaryTaskDialog>
      <DelayApprove ref="approveControl" @refershSource="refreshMode"></DelayApprove>
      <DelayApply ref="delayControl" @refershSource="refreshMode"></DelayApply>
    </el-row>
    <AppraiseDailog ref="appraiseDialog"></AppraiseDailog>
    <RecommendDialog ref="recommendDialog"></RecommendDialog>
    <AppraiseTaskTemplate ref="appraiseTaskTemplate"></AppraiseTaskTemplate>
    <AcceptTask
      ref="acceptTask"
      :taskId="taskId"
      :serverCenterIds="serverCenterIds"
      @successed="acceptTaskSuccess"
    ></AcceptTask>
    <taskDialog ref="taskDialog" :isGroup="true" @getValue="getTask"></taskDialog>
    <AppraiseInfo ref="appraiseInfo" :appraiseInfo="appraiseInfo"></AppraiseInfo>
    <SideTagsRecordDialog ref="SideTagsRecordDialog" @successed="refreshMode" pageType="1"></SideTagsRecordDialog>
    <taskRelationSetting
      :taskList="resultList"
      ref="taskRelationSetting"
      @setRelation="saveTaskRelation"
    ></taskRelationSetting>
  </div>
</template>

<script>
// import "@/styles/scrollbar.css";
import AcceptTask from "./AcceptTask.vue";
import DelayApply from "./../taskDelay/DelayApply.vue";
import AppraiseInfo from "@/views/task/Appraise/appraiseTaskInfoDialog.vue";
import AppraiseDailog from "../Appraise/appraiseTaskDialog.vue";
import RecommendDialog from "../Appraise/recommendDialog.vue";
import AppraiseTaskTemplate from "../Appraise/appraiseTaskTemplate.vue";
import DelayApprove from "./../taskDelay/DelayApprove.vue";
import { getToken } from "../../../util/auth";
import ConvertTask from "./ConvertTask.vue";
import evaTask from "./evaTask.vue";
import RelationTask from "./RelationTask.vue";
import evaluate from "./evaluate.vue";
// import CreateTask from "../common/CreateTask.vue";
import handOverTask from "./handOverTask.vue";
import taskRelationSetting from "../common/taskRelationSetting.vue";
import SideTagsSubtaskSubDialog from "./SideTagsSubtaskSubDialog.vue";
import AuditProcessTaskDialog from "./AuditProcessTaskDialog.vue";
import CompleteTask from "./CompleteTask.vue";
import summaryTaskDialog from "./summaryTaskDialog.vue";
// import SideTagsRecordDialog from "../components/SideTagsRecordDialog.vue";
import taskDialog from "@/components/basicTemplate/common/taskDialog.vue";
import { mapState } from "vuex";
import { UpdateTreePathName } from "@/api/modules/basicData/basicTask";
import api from "@/api/modules/basicData/cluster";
import folder from "@/api/modules/basicData/folder";
import { NewAuditFlow } from "ayb-form-design/src/api/WfEngine.js";
import {
  GetTastInfo,
  GetCurrentNodeIds,
} from "ayb-form-design/src/api/WfMyTask.js";

import comps from "ayb-form-design/src/helpers/comps";
import tool from "ayb-form-design/src/helpers/form";
import { GetFormData } from "ayb-form-design/src/api/custmerForm.js"; //GetSchemeEntity
import { SaveTableData } from "ayb-form-design/src/api/databaseTable.js";
import { Flow } from "ayb-form-design/src/api/WfEngine.js";
import { GetSchemeData } from "ayb-form-design/src/api/WFScheme.js";
import formTool from "ayb-form-design/src/helpers/form";
import {
  getAcceptTaskServerCenters,
  urgeTask,
  cancelTask,
  completeTask,
  rebackTask,
  addEvaluation,
  GetNoticeInstance,
  GetNoticeResult,
  updateTaskName,
  RejectReciveTask,
  canConvertTask,
  GetTaskTypeList,
  GetTaskScoreInfo,
  DelTaskByTaskId,
  GetTaskMemeber,
  AddTaskRelation,
  // summaryTask
} from "@/api/modules/basicData/task";
import { GetAuditProcess } from "@/api/modules/basicData/workFlow";
import icon from "../../../components/common/icon.vue";
const cookieUser = getToken();
export default {
  name: "Navbar",
  data() {
    return {
      typeInfo: {},

      ApprovalInfo: null,
      approval: null,
      node: {},

      taskId: "",
      curTaskId: "",
      StakeholderList: [], //干系人
      appraiseInfo: {},
      taskTypeInt: 0,
      groupId: this.$route.query.groupId,
      IsShowOnlyList: this.$route.query.type == "groupList" ? true : false,
      btnLeftRight: this.isRight ? "btn-normal" : "btn-left",
      processDelayShow: false,
      responseDelayShow: false,
      buttonSize: "mini",
      createTaskTitle: "新建任务",
      selectRadioType: 0,
      type: this.$route.query.type || 2,
      expand: false,
      acceptShow: false, //
      convertShow: false, //
      urgeShow: false, //
      cancelShow: false, //
      completeShow: false, //
      rebackShow: false, //
      appraise: false,
      appraise2: false,
      closeShow: false, //
      addWorkRecordShow: false,
      evaluateShow: false, //
      subTaskShow: false, //子任务
      subTaskFlowShow: false, //审批型子任务
      auditProcessShow: false, //审批流程
      relationShow: false, // 关联任务
      summaryShow: false, //
      deleteShow: false, //删除
      updateShow: false, //修改
      copyAddShow: false, //赋值创建
      createTaskShow: false, //生成任务
      updateNameShow: false, //修改名称
      curUserOnlineServerCenters: [],
      taskTypeList: JSON.parse(localStorage.getItem("TaskType")),
      myRowData: {
        userId: "",
        taskId: "",
        taskState: 1,
      },
      taskTypeName: "个人任务", //任务类型名称
      isEvaluate: true,
      fightServerCenters: JSON.parse(
        localStorage.getItem("FightServerCenters")
      ),
      curUserServerCenters: JSON.parse(
        localStorage.getItem("ServerCenterMember")
      ),
    };
  },
  props: {
    isRight: {
      type: Boolean,
      default: true,
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
    curTask: {
      type: Object,
      default: () => ({
        return: this.$store.state.task.curTask,
      }),
    },
    parentTask: {
      type: Object,
      default: () => null,
    },
    refreshType: {
      //按钮操作成功后刷新方式 0:更新列表 1：刷新页面
      type: Number,
      default: 0,
    },
    buttonType: {
      type: String,
      default: "primary",
    },
    taskGroup: {
      //默认显示任务组
      type: String,
      default: "",
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
    isCreateTeam: {
      //是否创建团队按钮
      type: Boolean,
      default: false,
    },
    isAddWorkRecord: {
      //是否添加工作记录
      type: Boolean,
      default: false,
    },
    isUrge: {
      //是否显示催办
      type: Boolean,
      default: true,
    },
    isEditName: {
      //是否显示修改名称
      type: Boolean,
      default: true,
    },
    isAddTo: {
      //是否显示添加到
      type: Boolean,
      default: false,
    },
    createName: {
      //创建名称
      type: String,
      default: "新建任务", //
    },
  },
  computed: {
    ...mapState({
      resultList: (state) => state.resultBase.resultList,
      parentInfo: (state) => state.folder.parentInfo,
      userId: (state) => state.task.userId,
      userName: (state) => state.task.realName,
      stateOptions: (state) => state.task.stateOptions,
      folderInfo: (state) => state.task.folderInfo,
      curUser: (state) => state.user,
      task: (state) => state.task.curTask,
      taskStyle: (state) => state.task.taskStyle,
      Person: (state) => state.folder.Person,
    }),
    userInfo() {
      let user = this.curUser;
      return {
        ID: user.userId,
        NAME: user.realName,
        DEPTID: user.departmentId,
        DEPTNAME: user.departmentName,
        COMPANYID: user.companyId,
        COMPANYNAME: user.companyName,
      };
    },
    // curTask: function() {
    //     return this.$store.state.task.curTask;
    // },
    expandIcon: function () {
      return this.expand ? "zhankai" : "zhankai-copy";
    },
    serverCenterIds: function () {
      if (this.curUserServerCenters) return this.curUserServerCenters.join(",");
      else return "";
    },
    taskGropuParent: function () {
      return this.$store.state.task.taskGropuParent;
    },
  },
  methods: {
    saveTaskRelation(value) {
      var vals = this.resultList
        .filter((o) => o.ID != value.TASKID)
        .map((row) => {
          return {
            TASKID: value.TASKID,
            RELATIONID: row.ID,
            RELATIONTYPE: value.RELATIONTYPE,
            STATESYNC: value.STATESYNC,
            STATECONSTRAINS: value.STATECONSTRAINS,
            CREATEUSERID: cookieUser.userId,
            CREATEUSERNAME: cookieUser.realName,
            CREATEDEPTID: cookieUser.departmentId,
            CREATEDEPTNAME: cookieUser.departmentName,
            CREATECOMPANYID: cookieUser.organizationId,
            CREATECOMPANYNAME: cookieUser.organizationName,
          };
        });

      AddTaskRelation(vals).then((result) => {
        if (result.ResultCode > 0) {
          this.$message({
            type: "success",
            message: "任务合并成功！",
          });
          this.$store.commit("setResult", []);
        } else {
          this.$message({
            type: "error",
            message: "任务合并成功失败！",
          });
        }
      });
    },
    setTaskRelation() {
      this.$refs.taskRelationSetting.dialogVisible = true;
    },
    addWorkRecord() {
      this.$refs.SideTagsRecordDialog.dialogFormVisible = true;
      this.$refs.SideTagsRecordDialog.addRecordRelation(
        this.curTask.ID,
        this.curTask.TASKNAME,
        0,
        this.curTask.INSTANCE
      );
    },
    createTeam() {
      this.$emit("createTeam");
    },
    addTo() {
      this.$refs.taskDialog.dialogVisible = true;
    },
    updateTemplate() {
      //更新自定义评估模板
      this.$refs.appraiseTaskTemplate.dialogVisible = true;
    },
    recommend() {
      //推荐
      this.$refs.recommendDialog.dialogVisible = true;
    },
    appraiseTask() {
      //评价任务
      this.$refs.appraiseDialog.dialogVisible = true;
    },
    appraiseTaskInfo() {
      let scoreInfo = {
        TaskId: this.task.ID,
        Person: this.userInfo,
      };
      GetTaskScoreInfo(scoreInfo).then((res) => {
        this.appraiseInfo = res;
        this.$refs.appraiseInfo.dialogVisible = true;
      });
    },
    getTask(arr) {
      console.log("arr", arr);
      let folderList = [];
      let dt = new Date();
      // arr.forEach(item => {
      //     folderList.push({
      //         NODEID: 0,
      //         NODETYPE: item.TASKTYPE == "E9354DE41375" ? 3 : 0,
      //         NODENAME: item.TASKNAME + "(" + item.INSTANCE + ")",
      //         CREATETIME: dt,
      //         // PNODEID: this.parentInfo.NODEID,
      //         // PNODENAME: this.parentInfo.NODENAME,
      //         // PNODETYPE: this.parentInfo.NODETYPE,
      //         RELATIONID: item.ID,
      //         RELATIONCREATETIME: new Date(item.CREATETIME),
      //         RELATIONTYPE: item.STATE,
      //         RELATIONTYPENAME: item.TASKSTATENAME,
      //         CREATEUSERID: this.userId,
      //         CREATEUSERNAME: this.userName,
      //         CHILDRENCOUNT: 0
      //     });
      // });
      let item = this.task;
      folderList.push({
        NODEID: 0,
        NODETYPE: item.TASKTYPE == "E9354DE41375" ? 3 : 0,
        NODENAME: item.TASKNAME,
        CREATETIME: dt,
        // PNODEID: this.parentInfo.NODEID,
        // PNODENAME: this.parentInfo.NODENAME,
        // PNODETYPE: this.parentInfo.NODETYPE,
        PRELATIONID: this.parentInfo.RELATIONID,
        PRELATIONTYPE: this.parentInfo.RELATIONTYPE,
        RELATIONID: item.ID,
        RELATIONCREATETIME: new Date(item.CREATETIME),
        RELATIONTYPE: item.STATE,
        RELATIONTYPENAME: item.TASKSTATENAME,
        CREATEUSERID: this.userId,
        CREATEUSERNAME: this.userName,
        CHILDRENCOUNT: 0,
      });

      if (folderList.length > 0) {
        folder
          //.InsertTaskIntoFolder(folderList, this.task.ID, 3)
          .InsertTaskIntoFolder(folderList, arr[0].ID, 3)
          .then((res) => {
            if (res.ResultCode == 1) {
              // this.refreshMode();
              this.$emit("GetAddGroupLoad");
            } else {
              this.$message.error({
                message: "错误，请重试",
                center: true,
              });
            }
          });
      }
    },
    // initTaskType() {
    //   // 初始化任务类型
    //   // GetTaskTypeList().then((res) => {
    //   //   if (!res) return;
    //   //   if (res.length > 0) {
    //   //     this.taskTypeList = res.filter((item) => item.ISMT == true);
    //   //   }
    //   // });
    //   this.taskTypeList = JSON.parse(localStorage.getItem("TaskType"));
    // },
    handleCommand(command) {
      this.getFullScreen(true);
      //下拉菜单触发函数
      let viewType = this.taskTypeList.find((item) => item.ID === command);
      console.log("viewType", viewType);
      if (viewType) {
        if (viewType.FORMID) {
          this.$refs.CreateTaskForm.openDialog(
            viewType,
            0,
            this.taskStyle,
            this.curTask
          );
        } else {
          this.$refs.CreateTask.OpenDialog(
            viewType,
            0,
            this.taskStyle,
            this.curTask
          );
        }

        // switch (viewType[0].NAME) {
        //     case "故障报修":
        //         this.taskTypeInt = 0;
        //         setTimeout(() => {
        //             this.$refs.CreateRepair.OpenDialog();
        //         }, 1000);
        //         break;
        //     case "事项":
        //         this.taskTypeInt = 1;
        //         setTimeout(() => {
        //             this.$refs.CreateItem.OpenDialog();
        //             this.$refs.CreateItem.newTaskType = "简版事项";
        //         }, 500);

        //         break;
        //     default:
        //         this.taskTypeInt = 2;
        //         setTimeout(() => {
        //             this.createTask();
        //             this.$refs.createControl.createTaskMeg.taskType = command;
        //         }, 1000);

        //         break;
        // }
      }
    },
    updateTaskHandle() {
      console.log("updateTaskHandle", this.task.TASKTYPE);
      let viewType = this.taskTypeList.filter(
        (item) => item.ID === this.task.TASKTYPE
      );
      console.log("viewType", viewType);

      this.$refs.CreateTask.OpenDialog(
        viewType[0],
        1,
        this.taskStyle,
        this.curTask
      );
    }, //编辑
    copyAddTaskHandle() {
      //复制创建
      this.$confirm("确认复制创建？").then((_) => {
        let viewType = this.taskTypeList.filter(
          (item) => item.ID === this.task.TASKTYPE
        );

        this.$refs.CreateTask.OpenDialog(viewType[0], 2);
      });
    },
    deleteTaskHandle() {
      //删除
      this.$confirm("确认删除？").then((_) => {
        DelTaskByTaskId(this.task.ID, this.Person).then((res) => {
          console.log("删除", res);
          this.refreshMode();
        });
      });
    },

    getFullScreen(isBool) {
      if (this.IsShowOnlyList) {
        parent.setFullScreen(isBool);
      }
    },
    refreshMode() {
      console.log("刷新方式：", this.refreshType);

      //刷新页面方式
      switch (this.refreshType) {
        case 0:
          this.$store.dispatch("changeTaskSource");
          break;
        case 1:
          window.location.reload();
          break;
        case 2:
          this.$store.dispatch("loadTreePathList");
          this.$store.dispatch("GetMyTaskTreePath");
          break;
        case 3:
          this.$store.dispatch("GetTaskGroupTaskList");
          this.$emit("successed");
        default:
          this.$store.dispatch("changeTaskSource");
          break;
      }
    },
    getValue(item) {
      console.log("reportData", item);
      console.log("refreshType", this.refreshType);
      if (this.refreshType == 2 && item.taskGroup) {
        let dt = new Date();

        this.$store.dispatch("AddTaskTreePath", [
          {
            NODEID: 0,
            NODETYPE: item.EVENTTYPE == "E9354DE41375" ? 3 : 0,
            NODENAME: item.EVENTNAME,
            CREATETIME: dt,
            PNODEID: this.parentInfo.NODEID,
            PNODENAME: this.parentInfo.NODENAME,
            PNODETYPE: this.parentInfo.NODETYPE,
            PRELATIONID: this.parentInfo.RELATIONID,
            PRELATIONTYPE: this.parentInfo.RELATIONTYPE,
            RELATIONID: item.ID,
            RELATIONCREATETIME: new Date(item.CREATETIME),
            RELATIONTYPE: item.TASKTYPE,
            RELATIONTYPENAME: TASKTYPENAME,
            // RELATIONTYPENAME: this.stateOptions.filter(
            //   p => p.value == item.STATE
            // ).label,
            CREATEUSERID: this.userId,
            CREATEUSERNAME: this.userName,
            CHILDRENCOUNT: 0,
          },
        ]);
        setTimeout(() => {
          this.refreshMode();
        }, 1500);
      }
      // else if (this.IsShowOnlyList) {
      //   let dt = new Date();

      //   this.$store.dispatch("AddChatGroupTask",
      //     {
      //       GROUPID:this.groupId,
      //       TASKID:item.ID
      //     }
      //   );
      //   setTimeout(() => {
      //     this.refreshMode();
      //   }, 1500);
      // }
      else {
        this.refreshMode();
      }
    },
    //显示进度延期申请
    showTaskProcess(task) {
      console.log("this.curTask.IsDelay", task.IsDelay);
      if (task.IsDelay) {
        if (!task.LastApplyInfoList) {
          this.processDelayShow = true;
          return;
        }
        if (task.LastApplyInfoList.length === 0) {
          this.processDelayShow = true;
          return;
        }
        if (task.LastApplyInfoList.findIndex((o) => o.DELAYTYPE === 0) < 0) {
          this.processDelayShow = true;
          return;
        }
      }
      this.processDelayShow = false;
    },
    //显示操作延期申请
    showTaskResponse(task) {
      console.log("this.curTask.IsResponseDelay", task.IsResponseDelay);
      if (task.IsResponseDelay) {
        if (!task.LastApplyInfoList) {
          this.responseDelayShow = true;
          return;
        }
        if (task.LastApplyInfoList.length === 0) {
          this.responseDelayShow = true;
          return;
        }
        if (task.LastApplyInfoList.findIndex((o) => o.DELAYTYPE === 1) < 0) {
          this.responseDelayShow = true;
          return;
        }
      }
      this.responseDelayShow = false;
    },
    showAddWorkRecord(task) {
      if (this.showAddWorkRecord) {
        GetTaskMemeber(task.ID, false).then((res) => {
          this.StakeholderList = res;
          if (res != null && res.some((o) => o.USERID == cookieUser.userId)) {
            this.addWorkRecordShow = true;
          } else {
            this.addWorkRecordShow = false;
          }
        });
      }
      // console.log('工作记录值',this.curTaskId != task.ID);
      // if (this.curTaskId != task.ID) {
      //   if (this.showAddWorkRecord) {
      //     GetTaskMemeber(task.ID, false).then(res => {
      //       this.StakeholderList = res;
      //       if (res != null && res.some(o => o.USERID == cookieUser.userId)) {
      //         this.addWorkRecordShow = true;
      //       } else {
      //         this.addWorkRecordShow = false;
      //       }
      //     });
      //   }
      //   this.curTaskId = task.ID;
      // } else {
      //   if (
      //     this.StakeholderList != null &&
      //     this.StakeholderList.some(o => o.USERID == cookieUser.userId)
      //   ) {
      //     this.addWorkRecordShow = true;
      //   } else {
      //     this.addWorkRecordShow = false;
      //   }
      // }
    },
    refershSource() {
      this.$store.dispatch("changeTaskSource");
    },
    evaTask() {
      // 评价任务
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.evaTask.dialogVisible = true;
      this.$refs.evaTask.addValue();
    },
    handOver() {
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.handOverTask.dialogVisible = true;
      this.$refs.handOverTask.connect();
    },
    showConvertTaskDialog() {
      canConvertTask(
        this.curTask.ID,
        cookieUser.userId,
        cookieUser.departmentId
      ).then((resultCode) => {
        if (resultCode < 0) {
          this.$message.warning("当前人员不能流转");
          return;
        } else {
          this.$store.dispatch("changeCurTask", this.curTask);
          this.$refs.convertControl.dialogVisible = true;
          this.typeInfo = this.taskTypeList.find(
            (item) => item.ID === this.curTask.TASKTYPE
          );
        }
      });
    },
    isNullOrEmptyStr(str) {
      return str == null || str === "";
    },
    isServerCenterMemeber(serverCenterId) {
      if (
        this.isNullOrEmptyStr(serverCenterId) ||
        this.curUserServerCenters == null ||
        this.curUserServerCenters.length === 0
      )
        return false;
      return this.curUserServerCenters.indexOf(serverCenterId) > -1;
    },
    expandSearch() {
      this.expand = !this.expand;
      this.$emit("searchExpand", this.expand);
    },
    //修改任务别名
    updateNewTaskName() {
      if (!this.curTask.ID && !this.isGroup) return;
      this.$prompt("新名称", "修改别名", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        if (this.isGroup) {
          var data = {
            Id: this.folderInfo.RELATIONID,
            Name: value,
            GroupType: 1,
            CreateUser: this.folderInfo.CREATEUSERID,
            CreateUserName: this.folderInfo.CREATEUSERNAME,
            TaskId: "",
            NickName: "",
          };
          api.updateCluster(data).then((res) => {
            // this.$emit('GetGroupMember',this.GroupId)
          });

          let obj = {
            Name: value,
            RelationId: this.folderInfo.RELATIONID,
            NodeType: this.folderInfo.NODETYPE,
          };
          UpdateTreePathName(obj).then((res) => {
            if (res.ResultCode > 0) {
              this.$store.dispatch("loadTreePathList");
            } else {
              this.$message.error("错误,请重试！");
            }
          });
        } else {
          updateTaskName(
            {
              ID: cookieUser.userId,
              NAME: cookieUser.realName,
              DEPTID: cookieUser.departmentId,
              DEPTNAME: cookieUser.departmentName,
              COMPANYID: cookieUser.companyId,
              COMPANYNAME: cookieUser.companyName,
            },
            this.curTask.ID,
            value
          ).then((resultMsg) => {
            if (resultMsg.ResultCode > 0) {
              this.$message.success("修改成功");
              this.refreshMode();
            } else {
              this.$message.error(resultMsg.MsgInfo);
            }
          });
        }
      });
    },
    //延期任务进度
    delayTaskProcess() {
      this.$refs.delayControl.loadTask(this.curTask, 0);
    },
    //任务响应延期
    delayTaskResponse() {
      this.$refs.delayControl.loadTask(this.curTask, 1);
    },
    unAcceptTaskHandle() {
      this.$prompt("填写拒绝原因", "不接收任务", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        RejectReciveTask(this.curTask.ID, value, {
          ID: cookieUser.userId,
          NAME: cookieUser.realName,
          DEPTID: cookieUser.departmentId,
          DEPTNAME: cookieUser.departmentName,
          COMPANYID: cookieUser.companyId,
          COMPANYNAME: cookieUser.companyName,
        }).then((resultMsg) => {
          if (resultMsg.ResultCode > 0) {
            // let taskNodeInfo = await GetTastInfo(this.curTask.ID).then(
            //   result => {
            //     return result.data;
            //   }
            // );
            // let currentNode = tool.breadthQuery(
            //   this.currentNode,
            //   taskNodeInfo.F_NodeId
            // );
            let viewType = this.taskTypeList.find(
              (item) => item.ID === this.curTask.TASKTYPE
            );
            if (this.getIsFlow(viewType)) {
              NewAuditFlow(
                "",
                this.curTask.ID,
                2,
                value,
                "",
                JSON.stringify({}),
                JSON.stringify({}),
                false
              ).then((res) => {
                if (res.status !== 1) {
                  this.$message.error("不接收任务失败");
                }
              });
            }
            this.$message.success("拒绝成功");
            this.refreshMode();
          } else {
            this.$message.error(resultMsg.MsgInfo);
          }
        });
      });
    },
    acceptTaskHandle() {
      this.$refs.acceptTask.dialogVisible = true;
    },
    acceptTaskSuccess() {
      this.refreshMode();
    },
    urgeTaskHandle() {
      this.$prompt("请输入催办内容", "催办任务", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        if (!value) {
          this.$message.info("请输入催办内容");
          return false;
        } else if (!this.trim(value)) {
          this.$message.info("请输入催办内容");
          return false;
        }
        urgeTask(this.curTask.ID, value, cookieUser.userId).then(
          (resultCode) => {
            if (resultCode > 0) {
              this.$message.success("催办成功");
            } else {
              this.$message.error("催办失败");
            }
          }
        );
      });
    },
    cancelTaskHandle() {
      this.$confirm("确定要作废此任务?", "提示", {
        type: "warning",
      })
        .then(() => {
          cancelTask(this.curTask.ID, {
            NAME: cookieUser.realName,
            ID: cookieUser.userId,
            DEPTID: cookieUser.departmentId,
            DEPTNAME: cookieUser.departmentName,
          }).then((resultCode) => {
            if (resultCode > 0) {
              let viewType = this.taskTypeList.find(
                (item) => item.ID === this.curTask.TASKTYPE
              );
              if (this.getIsFlow(viewType)) {
                NewAuditFlow(
                  viewType.FLOWID,
                  this.curTask.ID,
                  2,
                  "作废",
                  JSON.stringify({}),
                  JSON.stringify({}), //JSON.stringify(currentNode),
                  JSON.stringify({}),
                  true
                ).then((res) => {
                  if (res.status !== 1) {
                    this.$message.error("作废任务失败");
                  }
                });
              }
              this.$message.success("作废成功");
              this.refreshMode();
            } else {
              this.$message.error("作废任务失败");
            }
          });
        })
        .catch(() => {}); //一定别忘了这个
    },
    completeTaskHandle() {
      // let completInfo={
      //   TaskId:this.curTask.ID,
      //   ServerId:this.serverCenterIds,
      //   replyContent:'',
      //   UserName:cookieUser.realName,
      //   UserId:cookieUser.userId,
      //   DeptId:cookieUser.departmentId,
      //    DeptName:cookieUser.departmentName
      // };
      // this.$refs.completeControl.dialogVisible = true;
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.completeControl.openDialog();
      // completeTask(completInfo).then(resultMsg=>{
      //   if(resultMsg.ResultCode)
      //   {
      //     this.$message.success('完成成功');
      //     this.$store.dispatch('changeTaskSource');
      //   }else{
      //     this.$message.error("完成任务失败");
      //   }
      // });
    },
    rebackTaskHandle() {
      this.$prompt("打回原因", "打回任务", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        let rebackInfo = {
          TaskId: this.curTask.ID,
          ServerId: this.serverCenterIds,
          ReplyContent: value,
          UserName: cookieUser.realName,
          UserId: cookieUser.userId,
          DeptId: cookieUser.departmentId,
          // DeptName:cookieUser.departmentName
        };
        rebackTask(rebackInfo).then((resultCode) => {
          if (resultCode > 0) {
            this.$message.success("打回成功");
            this.refreshMode();
          } else {
            this.$message.error("打回任务失败");
          }
        });
      });
    },
    evaluationTaskHandle() {
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.evaluate.dialogVisible = true;
      this.$refs.evaluate.task = this.finishTask;
      this.$refs.evaluate.getTask();
      this.$refs.evaluate.addValue();
    },
    summaryTaskHandle() {
      // this.$refs.summaryTaskDialog.summaryTaskDialogVisible=true;
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.summaryTaskDialog.TaskSummary();
    },
    //是否包含固定审批功能
    getIsFlow(viewType) {
      if (viewType.FLOWID) {
        return true;
      } else {
        return false;
      }
    },
    NewAuditFlow(verifyType = 1, description = "", ApprovalInfo = {}) {
      let viewType = this.taskTypeList.find(
        (item) => item.ID === this.curTask.TASKTYPE
      );
      if (viewType.FLOWID) {
        NewAuditFlow(
          "",
          this.curTask.ID,
          verifyType,
          description,
          JSON.stringify(ApprovalInfo.approval[0]),
          JSON.stringify(ApprovalInfo.node), //JSON.stringify(currentNode),
          JSON.stringify({}),
          true
        ).then((res) => {
          if (res.status !== 1) {
            this.$message.error("作废任务失败");
          }
        });
      }
    },
    createTask() {
      this.$refs.createControl.OpenDialog();
      this.$refs.createControl.title = "新建报修";
      this.$refs.createControl.workflowName = "";
      this.$refs.createControl.type = 1;
      this.$refs.createControl.processId = "";
      this.$refs.createControl.ReceiverProp = "ReceiveUserName";
    },
    SubTask() {
      // if (this.task.STATE == 0) {
      //   this.AcceptTask(this.task);
      // };
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.SideTagsSubtaskSubDialog.dialogFormVisible = true;
      this.$refs.SideTagsSubtaskSubDialog.type = 1;
      this.$refs.SideTagsSubtaskSubDialog.title = "新建报修";
    },
    SubFlowTask() {
      this.$refs.createControl.dialogVisible = true;
      this.$refs.createControl.title = "服务申请";
      this.$refs.createControl.workflowName = "";
      this.$refs.createControl.type = 2;
      this.$refs.createControl.processId = "";
      this.$refs.createControl.ReceiverProp = "ReceiveUserName";
    },
    AuditProcessTask() {
      //审核流程事件
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.AuditProcessTaskDialog.dialogVisible = true;
      // this.$refs.AuditProcessTaskDialog.onAuditer();
    },
    realationTask() {
      // 关联任务
      this.$store.dispatch("changeCurTask", this.curTask);
      this.$refs.relationTask.dialogVisible = true;
    },
    acceptTask() {
      //接收任务

      let data = {
        TaskId: this.curTask.ID,
        ServerId: this.serverCenterIds,
        // "ServerId": this.curTask.SERVERCENTERID,
        UserName: cookieUser.realName,
        UserId: cookieUser.userId,
        DeptId: cookieUser.departmentId,
        DeptName: cookieUser.departmentName,
      };
      acceptTask(data).then((res) => {
        // if (res.ResultCode == 1) {
        //   alert('成功');
        // } else {
        //   alert('失败');
        // }
      });
    },
    selectRadioTypeChange(val) {
      this.$store.commit("setSelectRadioType", val);
    },
    async getPowerButton(task) {
      console.log(task, "task");
      this.taskId = task.ID;
      this.acceptShow = false; //
      this.convertShow = false; //
      this.urgeShow = false; //
      this.cancelShow = false; //
      this.completeShow = false; //
      this.rebackShow = false; //
      this.evaluateShow = false; //
      this.subTaskShow = false; //子任务
      this.subTaskFlowShow = false; //
      this.auditProcessShow = false; //审批流程
      this.summaryShow = false; //
      this.closeShow = false;
      this.addWorkRecordShow = false;
      this.appraise = false;
      this.appraise2 = false;
      this.relationShow = false;
      this.deleteShow = false; //删除
      this.updateShow = false; //修改
      this.copyAddShow = false; //赋值创建
      this.createTaskShow = false; //生成任务
      this.updateNameShow = false; //修改名称
      console.log("task watch", task);
      if (!task.ID) return;
      this.showTaskProcess(task);
      this.showTaskResponse(task);
      this.showAddWorkRecord(task);
      switch (this.taskStyle) {
        case 1: //
          this.deleteShow = task.CREATEUSERID == cookieUser.userId; //删除
          this.updateShow = task.CREATEUSERID == cookieUser.userId; //修改
          break;
        case 2: //
          this.deleteShow = task.CREATEUSERID == cookieUser.userId; //删除
          this.updateShow = task.CREATEUSERID == cookieUser.userId; //修改
          this.copyAddShow = true; //赋值创建
          this.createTaskShow = true; //生成任务
          break;
        default:
          this.deleteShow = false; //删除
          this.updateShow = false; //修改
          break;
      }

      if (this.taskStyle == 1 || this.taskStyle == 2) return false;

      this.updateNameShow =
        task.EXCUTEUSERID == cookieUser.userId ||
        task.CREATEUSERID == cookieUser.userId;
      this.subTaskShow =
        (task.STATE == 0 || task.STATE == 1) &&
        (!task.EXCUTEUSERID
          ? false
          : task.EXCUTEUSERID == cookieUser.userId
          ? true
          : false);
      this.subTaskFlowShow =
        (task.STATE == 0 || task.STATE == 1) &&
        (task.EXCUTEUSERID == cookieUser.userId ||
          task.CREATEUSERID == cookieUser.userId);
      this.typeInfo = this.taskTypeList.find(
        (item) => item.ID === this.curTask.TASKTYPE
      );
      this.ApprovalInfo = null;
      if (this.typeInfo) {
        if (this.typeInfo.FLOWID) {
          let node = await GetSchemeData(this.typeInfo.FLOWID).then(
            (result) => {
              if (result.code === 200) {
                return JSON.parse(result.data.schemeEntity.F_Scheme).node;
              } else {
                this.$message.warning("获取模板数据有问题，请重试！");
              }
            }
          );
          let taskNodeInfo = await GetCurrentNodeIds(this.curTask.ID).then(
            (result) => {
              return result.data;
            }
          );
          this.node = node;
          let dbTable = [];
          if (this.typeInfo.FORMID) {
            dbTable = await GetFormData(this.typeInfo.FORMID).then((result) => {
              return JSON.parse(result.schemeEntity.F_Scheme).data[0];
            });
          }
          let ApprovalInfo = await formTool.getApproval(
            node,
            taskNodeInfo[0],
            {},
            1,
            1,
            dbTable.length > 0
              ? { tablename: dbTable[0].name, taskid: this.curTask.ID }
              : ""
          );
          this.ApprovalInfo = ApprovalInfo;
          if (ApprovalInfo.approval.length > 0)
            this.approval = ApprovalInfo.approval[0];
        }
      }
      switch (task.STATE) {
        case 0: //待接收 5作废  2分派子任务 1流转 0 接收
          if (this.curUserServerCenters.length === 0) {
            //非客服 如果是可抢单运维或者是执行人

            let visible =
              (this.isNullOrEmptyStr(task.EXCUTEUSERID) &&
                this.fightServerCenters.indexOf(task.SERVERCENTERID) > -1) ||
              task.EXCUTEUSERID === cookieUser.userId;
            console.log("非客服", visible);
            this.acceptShow = visible;
            this.convertShow = visible;
            this.cancelShow =
              task.CREATEUSERID === cookieUser.userId ||
              visible ||
              this.isServerCenterMemeber(task.CREATESERVERCENTERID);
          } else {
            //无接收人

            if (this.isNullOrEmptyStr(task.EXCUTEUSERID)) {
              let visible =
                this.isServerCenterMemeber(task.SERVERCENTERID) ||
                this.fightServerCenters.indexOf(task.SERVERCENTERID) !== -1;
              console.log(
                "如果是当前服务台客服或者是可抢单的运维人员",
                visible
              );
              this.cancelShow =
                task.CREATEUSERID === cookieUser.userId ||
                visible ||
                this.isServerCenterMemeber(task.CREATESERVERCENTERID);
              this.convertShow = visible;
              this.acceptShow = visible;
            } else {
              //有接收人，
              console.log("有接收人，");
              let ss =
                task.CREATEUSERID === cookieUser.userId ||
                this.isServerCenterMemeber(task.CREATESERVERCENTERID);
              console.log("创建人是我 或者服务台是我当前的服务台", ss);
              //我是创建服务台当班人员，则有作废权
              this.cancelShow =
                task.CREATEUSERID === cookieUser.userId ||
                this.isServerCenterMemeber(task.CREATESERVERCENTERID);
              this.convertShow = task.EXCUTEUSERID === cookieUser.userId;
              this.acceptShow = task.EXCUTEUSERID === cookieUser.userId;
            }
          }
          this.convertShow = this.ApprovalInfo
            ? this.ApprovalInfo.isFinished
              ? false
              : this.convertShow
            : this.convertShow;
          console.log("convertShow", this.convertShow);
          this.relationShow =
            task.CREATEUSERID === cookieUser.userId ||
            task.EXCUTEUSERID === cookieUser.userId;
          break;
        case 1: //
          console.log("task.EXCUTEUSERID " + task.EXCUTEUSERID);
          if (task.EXCUTEUSERID === cookieUser.userId) {
            if (!task.HasSummary) this.summaryShow = true; //
            this.completeShow = this.ApprovalInfo
              ? !this.ApprovalInfo.isFinished
                ? false
                : true
              : true;
            this.convertShow = this.ApprovalInfo
              ? this.ApprovalInfo.isFinished
                ? false
                : true
              : true;
          }
          this.relationShow =
            task.CREATEUSERID === cookieUser.userId ||
            task.EXCUTEUSERID === cookieUser.userId;
          if (task.CREATEUSERID === cookieUser.userId) this.urgeShow = true;
          break;
        case 2:
          this.finishTask = task;
          if (task.CREATEUSERID == cookieUser.userId) {
            this.isEvaluate = task.ISEVALUTION;
          }
          if (task.CREATEUSERID === cookieUser.userId) {
            this.rebackShow = true;
            this.closeShow = true;
          }
          if (task.EXCUTEUSERID === cookieUser.userId) {
            if (!task.HasSummary) this.summaryShow = true; //
          }
          if (
            task.EXCUTEUSERID !== cookieUser.userId &&
            task.ISEVALUTION === false
          ) {
            this.appraise = true;
          }
          if (
            task.EXCUTEUSERID !== cookieUser.userId &&
            task.ISEVALUTION === true
          ) {
            this.appraise2 = true;
          }
          break;
        case 3:
          if (task.CREATEUSERID == cookieUser.userId) {
            this.isEvaluate = task.ISEVALUTION;
          }
        case 4:
          //处理审批流程按钮权限
          // GetAuditProcess(task.WORKFLOWID, cookieUser.userId).then(res => {
          //   this.auditProcessShow = res;
          // });
          this.auditProcessShow = false;
          break;
        default:
          break;
      }
    },
  },
  created() {
    // getAcceptTaskServerCenters(cookieUser.userId).then(centers => {
    //   this.fightServerCenters = centers;
    // });
    if (this.curTask) this.getPowerButton(this.curTask);

    // GetAllManageServerCenterByUserId(cookieUser.userId).then(centers => {
    //   this.curUserServerCenters = centers.map(function(item) {
    //     return item.ID;
    //   });
    //   // console.log("created", this.showCreateButton);
    //   // let showbtn = this.showCreateButton;
    //   // this.$nextTick(() => {
    //   //   console.log("created nextTick", this.showCreateButton);
    //   //   this.showCreateButton = showbtn;
    //   // });
    // });
  },
  watch: {
    curTask(task, oldval) {
      if (task) {
        this.getPowerButton(task);
      }
    },
    task(task, oldval) {
      if (task) {
        this.getPowerButton(task);
      }
    },
  },
  mounted() {
    // this.initTaskType();
    switch (this.$route.query.type) {
      case "1":
        this.taskTypeName = "服务台任务";
        this.createTaskTitle = "新建任务";
        break;
      case "2":
        this.taskTypeName = "个人任务";
        break;
      case "3":
        this.taskTypeName = "任务组";
        this.createTaskTitle = "新建组型任务";
        break;
      default:
        this.taskTypeName = "个人任务";
        this.createTaskTitle = "新建任务";
        break;
    }
  },
  components: {
    AppraiseInfo,
    AcceptTask,
    AppraiseTaskTemplate,
    RecommendDialog,
    DelayApprove,
    DelayApply,
    icon,
    taskRelationSetting,
    ConvertTask,
    CompleteTask,
    // CreateTask,
    handOverTask,
    SideTagsSubtaskSubDialog,
    evaluate,
    AuditProcessTaskDialog,
    evaTask,
    summaryTaskDialog,
    AppraiseDailog,
    // taskDialog,
    // SideTagsRecordDialog
  },
};
</script>

<style scoped>
.el-button + .el-button {
  margin-left: 0px;
}

.el-button {
  font-size: 16px;
}

.el-button--mini,
.el-button--mini.is-round {
  padding: 5px 8px;
}

.but {
  text-align: right;
}

.leftgroup {
  float: left;
  width: 35px;
  height: 35px;
  background-color: #2b7cff;
  border-radius: 4px 0px 0px 4px;
}

.rightgroup {
  width: 35px;
  height: 35px;
  background-color: #ffffff;
  border-radius: 0px 4px 4px 0px;
  border: solid 1px #d5dae6;
  float: left;
}

.card {
  width: 17px;
  height: 17px;
  margin-left: -9px;
  margin-top: -4px;
  background: url(../../../../src/assets/img/card.png);
}

.list {
  width: 17px;
  height: 17px;
  margin-left: -8px;
  margin-top: -4px;
  background: url(../../../../src/assets/img/list.png);
}

.breadcrumb {
  background: white;
  font-size: 16px;
  padding: 8px;
}

.btn-hidden {
  visibility: hidden;
  display: none;
}

.btn-normal {
  float: right;
  margin: 0 2px;
}

.btn-left {
  float: left;
  margin: 0 2px;
}
</style>
